import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AdministrativeIndicationsReportService, IndicationScheduleDocument } from '../../../../../../../services/administrative-indications-report-v2.service';

@Component({
    selector: 'app-schedule-documents-list',
    templateUrl: './schedule-documents-list.component.html',
    styleUrls: ['./schedule-documents-list.component.scss'],
})
export class ScheduleDocumentsListComponent {
    @Input() documents: IndicationScheduleDocument[] = [];
    @Input() indicationId: number;
    @Output() statusChanged = new EventEmitter<void>();

    updatingDocumentId: number | null = null;

    constructor(
        private readonly service: AdministrativeIndicationsReportService,
        private readonly snack: MatSnackBar
    ) {}

    toggleActiveStatus(doc: IndicationScheduleDocument): void {
        if (this.updatingDocumentId) return;

        const isActive = !doc.isActive;
        this.updatingDocumentId = doc.id;
        this.service.setDocumentActiveStatus(this.indicationId, doc.id, isActive).subscribe(
            () => {
                this.updatingDocumentId = null;
                this.snack.open(isActive ? 'Laudo reativado com sucesso.' : 'Laudo inativado com sucesso.', undefined, { duration: 2000 });
                this.statusChanged.emit();
            },
            () => {
                this.updatingDocumentId = null;
                this.snack.open('Não foi possível atualizar o status do laudo. Tente novamente.', undefined, { duration: 3000 });
            }
        );
    }
}
